import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { render } from "react-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./CSS/Notification.css";
import loading_ from "../Assets2/loading.gif";
import BtnCellRenderer from "./BtnCellRenderer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Notifications = (props) => {
  const [loading, SetLoading] = useState(true);

  const history = useHistory();
  const [inital_tag, Set_inital_tag] = useState(0);

  setInterval(() => {
    if (window.location.pathname === "/notifications") {
      if (loading !== true && document.querySelector(".details_noti") !== null)
        Set_inital_tag(
          document.querySelector(".details_noti").classList.length
        );
    }
  }, 1000);

  const [state, Setstate] = useState([]);
  const [info, Setinfo] = useState([
    {
      message: "",
      id: "",
      tagId: "",
      tagValue: "",
      statusCode: "",
      date: "",
      confirm: "",
      tagName: "",
    },
  ]);

  useEffect(() => {
    setTimeout(() => {
      const ComponentDidMount = async () => {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetNotificationList",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                companyId: props.ucer_id,
              }),
            }
          );

          const response = await request.json();

          console.log(response);
          Setstate(response);

          if (request.status === 200) {
            let newData = [];
            for (let i of response) {
              const dateTime = new Date(i.date);

              const day = dateTime.getDate();
              const month = dateTime.getMonth() + 1;
              const year = dateTime.getFullYear();
              const hour = dateTime.getHours();
              const minute = dateTime.getMinutes();
              let second = dateTime.getSeconds();

              if(second<10){
                second = "0"+String(second);
              }

              // İstediğiniz formatta tarih ve saat bilgisini oluştur
              const formattedDateTime = `${day}/${month}/${year} - ${hour}:${minute}:${second}`;
              newData.push({
                ID: i.id,
                Message: i.message,
                TagID: i.tagId,
                Date: formattedDateTime,
                Status_Code: i.statusCode,
                Confirm: i.confirm_,
              });
            }
            newData = newData.reverse();
            setRowData(newData);
            SetLoading(false);
          }
        } catch (err) {
          console.log(err);
          SetLoading(true);
        }
      };
      ComponentDidMount();
    }, 800);
  }, []);

  useEffect(() => {
    if (!loading) {
      let obj_ = {
        message: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-message"),
        id: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-id"),
        tagId: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-id_tag"),
        tagValue: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-tagValue"),
        statusCode: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-statusCode"),
        date: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-date"),
        confirm: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-confirm"),
        tagName: document
          .querySelector(".notifications-kapsiyici")
          .getAttribute("data-tagName"),
      };

      Setinfo([obj_]);
    }
  }, [inital_tag]);

  const [rowData, setRowData] = useState(null);

  const [columnDefs] = useState([
    { field: "ID" },
    { field: "Message" },
    { field: "TagID" },
    { field: "Date" },
    { field: "Status_Code" },
    { field: "Confirm", cellRenderer: BtnCellRenderer },
  ]);

  const closePopUp = () => {
    document
      .querySelector(".pop_up_noti")
      .classList.toggle("pop_up_noti_active");
  };

  useEffect(() => {
    console.log(info);
  }, [info]);

  return (
    <>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="loading"
        >
          <img style={{ width: "15%" }} src={loading_} alt="" />
        </div>
      ) : (
        <>
          <div className="pop_up_noti details_noti">
            <i onClick={closePopUp} className="fa fa-times"></i>
            <div className="row">
              <span>ID: </span>
              <span>{info[0].id}</span>
            </div>
            <div className="row">
              <span>Tag Name: </span>
              <span>{info[0].tagName}</span>
            </div>
            <div className="row">
              <span>Message: </span>
              <span>{info[0].message}</span>
            </div>
            <div className="row">
              <span>Date: </span>
              <span>{info[0].date}</span>
            </div>
            <div className="row">
              <span>Status Code:</span>
              <span>{info[0].statusCode}</span>
            </div>
            <div className="row">
              <span>Tag Value:</span>
              <span>{info[0].tagValue}</span>
            </div>
            <div className="row">
              <span>Tag Id: </span>
              <span>{info[0].tagId}</span>
            </div>
          </div>
          <div
            data-message=""
            data-tagName=""
            data-confirm=""
            data-date=""
            data-tagValue=""
            data-statusCode=""
            data-id=""
            data-id_tag=""
            id="notifications-kapsiyici-id"
            className="notifications-kapsiyici"
          >
            <div
              className="ag-theme-alpine"
              style={{
                height: "70vh",
                width: "100%",
                overflow: "hidden",
                overflowY: "auto",
                marginTop: "10%",
              }}
            >
              <AgGridReact
                context={JSON.stringify(state)}
                rowData={rowData}
                columnDefs={columnDefs}
              ></AgGridReact>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    ucer_id: state.project_reducer.company_id,
    noti_list: state.project_reducer.notifications,
  };
};

export default connect(MapStateToProps)(Notifications);
